module.exports = __webpack_public_path__ + "img/down_4.86d7ca29.jpg";